module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/MadMax.009bf90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/MadMax.jpg
// module id = DVQ7
// module chunks = 0